import { render } from "./SignUpPage.vue?vue&type=template&id=44dcdb47"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__